import { messstelle, kenngroesse } from '../../../utils/apiTypes';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { colNameType, kenngroesseGruppeZeitPqIndex, pqIndexResult } from "./pqIndexTypes";
import { postJsonWithAuth } from "../../../utils/api";
import { logError, convertDateToWeekNumber } from "../../../utils/utils";
import { errorHandler } from '../../../utils/errorHandling';

const initialState: kenngroesseGruppeZeitPqIndex
  = {

  kenngroesse_zeitListe: [],
  kenngroesseZeit: [],
  kenngroesse_minZeit: [],
  kenngroesse_minKenngroesse: [],
  minKenngroesseZeitAll: 10,
  loadingKenngroesseZeit: false,
}

const kenngroesseGruppeZeitPqIndexSlice = createSlice({
  name: "kenngroesseGruppeZeitPqIndex",
  initialState,
  reducers:
  {
    setKenngroesse_zeitListe: (state, action: PayloadAction<colNameType[]>) => {
      state.kenngroesse_zeitListe = action.payload;
    },
    setKenngroesseMinZeitListe: (state, action: PayloadAction<number>) => {
      state.kenngroesse_minZeit.push(action.payload);
    },
    emptyKenngroesseMinZeitListe: (state) => {
      state.kenngroesse_minZeit = [];
    },
    setKenngroesseMinKenngroesseListe: (state, action: PayloadAction<number>) => {
      state.kenngroesse_minKenngroesse.push(action.payload);
    },
    emptyKenngroesseMinKenngroesseListe: (state) => {
      state.kenngroesse_minKenngroesse = [];
    },
    setMinKenngroesseZeitAll: (state, action: PayloadAction<number>) => {
      state.minKenngroesseZeitAll = action.payload;
    },
    setKenngroesseZeit: (state, action: PayloadAction<Array<Array<pqIndexResult>>>) => {
      state.kenngroesseZeit = action.payload;
    },
    setLoadingKenngroesseZeit: (state, action: PayloadAction<boolean>) => {
      state.loadingKenngroesseZeit = action.payload;
    },
  }
});

export const selectKenngroesseZeitListe = (state: RootState): colNameType[] => state.kenngroesseGruppeZeitPqIndex.kenngroesse_zeitListe;
export const selectKenngroesseMinZeitListe = (state: RootState): number[] => state.kenngroesseGruppeZeitPqIndex.kenngroesse_minZeit;
export const selectKenngroesseMinKenngroesseListe = (state: RootState): number[] => state.kenngroesseGruppeZeitPqIndex.kenngroesse_minKenngroesse;
export const selectKenngroesseMinZeitAll = (state: RootState): number => state.kenngroesseGruppeZeitPqIndex.minKenngroesseZeitAll;
export const selectKenngroesseZeit = (state: RootState): pqIndexResult[][] => state.kenngroesseGruppeZeitPqIndex.kenngroesseZeit;
export const selectLoadingKenngroesseZeit = (state: RootState): boolean => state.kenngroesseGruppeZeitPqIndex.loadingKenngroesseZeit;

export const getKenngroesseZeit =
  (messstelleParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, pqIndexMinParam: number, pqIndexMaxParam: number, grenzwertsatz: string, grupByUWParam: boolean, groupByKenngroessenkategorieParam: boolean) => (
    dispatch: AppDispatch): void => {

    const body = {
      start: startParam,
      end: endeParam,
      kenngroessen: kenngroesseParam,
      messstellen: messstelleParam,
      pqIndexMin: pqIndexMinParam,
      pqIndexMax: pqIndexMaxParam,
      grenzwertsatzName: grenzwertsatz
    }

    dispatch(setLoadingKenngroesseZeit(true))
    postJsonWithAuth("PQINDEXKENNGROESSEZEIT", { groupByUw: grupByUWParam, groupByKenngroessenkategorie: groupByKenngroessenkategorieParam }, body)
      .then((response: Array<Array<pqIndexResult>>) => {
        dispatch(emptyKenngroesseMinZeitListe());
        dispatch(emptyKenngroesseMinKenngroesseListe());
        dispatch(setKenngroesseZeit(response))
        const kwList: Array<colNameType> = [];
        let tempMinUwAll = 10;
        let tempMinZeitAll = 10;

        response.forEach(rows => {
          let tempMin = rows[0].value === null || rows[0].value === undefined ? 10 : rows[0].value;
          rows.forEach(row => {
            const dateTemp: Date = new Date(row.col);
            const convertWeekNumber = convertDateToWeekNumber(dateTemp);
            const yearOfWeekNumber = dateTemp.getFullYear();
            const colElem: colNameType = { name: convertWeekNumber.toString().length > 1 ? "KW " + "(" + yearOfWeekNumber + ") " + convertWeekNumber : "KW " + "(" + yearOfWeekNumber + ") " + "0" + convertWeekNumber, col: row.col }
            kwList.push(colElem)
            if (row.value !== null && row.value !== undefined) {
              if (tempMin > row.value) {
                tempMin = row.value
              }
            }
          })
          dispatch(setKenngroesseMinKenngroesseListe(tempMin))
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinUwAll > tempMin) {
              tempMinUwAll = tempMin;
            }
          }
        })

        kwList.sort((a, b) => a.name.localeCompare(b.name))
        const filterdKwList: Array<colNameType> = kwList.filter(function (elem, pos, self) {
          return self.findIndex((x) => (
            x.name === elem.name && x.col === elem.col
          )) == pos
        })

        filterdKwList.forEach(zeitElem => {
          const initData = response[0][0];
          let tempMin = 11;
          const dateTempInit = initData.col;
          if (zeitElem.col == dateTempInit) {
            tempMin = initData.value;
          }
          response.forEach(rows => {
            rows.forEach(row => {
              const dateTempCol = row.col;
              if (zeitElem.col == dateTempCol) {
                if (row.value !== null && row.value !== undefined) {
                  if (tempMin > row.value) {
                    tempMin = row.value
                  }
                }
              }
            })
          })
          dispatch(setKenngroesseMinZeitListe(tempMin));
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinZeitAll > tempMin) {
              tempMinZeitAll = tempMin;
            }
          }
        })

        dispatch(setKenngroesse_zeitListe(filterdKwList));
        dispatch(setMinKenngroesseZeitAll(tempMinUwAll < tempMinZeitAll ? tempMinUwAll : tempMinZeitAll))



      })
      .catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
      }).finally(() => dispatch(setLoadingKenngroesseZeit(false)));
  };

export const {
  setKenngroesse_zeitListe,
  setMinKenngroesseZeitAll,
  setKenngroesseMinZeitListe,
  emptyKenngroesseMinZeitListe,
  setKenngroesseMinKenngroesseListe,
  emptyKenngroesseMinKenngroesseListe,
  setKenngroesseZeit,
  setLoadingKenngroesseZeit,
} = kenngroesseGruppeZeitPqIndexSlice.actions;

export default kenngroesseGruppeZeitPqIndexSlice.reducer;